export default {
  namespaced: true,
  state: {
    items: [],
    roles:[
      {value: "ROLE_SUPER_ADMIN", text : "Super admin"},
      {value: "ROLE_ADMIN", text : "Admin"},
      {value: "ROLE_USER", text : "Utilisateur"},
      {value: "ROLE_TECHNICIAN", text : "Technicien"},
      {value: "ROLE_AGENT", text : "Coordinateur"},
    ],
  },
  getters: {
    // Par défaut on n'affiche jamais les superadmin
    getAll: state => state.items.filter(item => item.roles && !item.roles.includes('ROLE_SUPER_ADMIN')),
    getItem: state => id => state.items.find(item => item.id == id),
    getRoles: state => state.roles,
    getRole: state => role => state.roles.find(item => item.value == role)
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'user',
        api_data_path: 'users',
        namespace: 'user'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'user/index/simple',
        api_data_path: 'users',
        namespace: 'user'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'user',
        namespace: 'user',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'user',
        namespace: 'user',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'user',
        namespace: 'user',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'user',
        namespace: 'user',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/user.js